import { Button, Dialog, DialogContent, DialogTitle } from '@e2n/ui';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { useApiAktivierung } from '../hooks/useApiAktivierung';

type AktivierenDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export function AktivierenDialog({
  open,
  onOpenChange,
}: AktivierenDialogProps) {
  const { t } = useTranslation();
  const { setzeAktiv, loading } = useApiAktivierung();

  async function handleConfirm() {
    if (await setzeAktiv(true)) {
      onOpenChange(false);
      return;
    }

    toast.error(t('domain.e2nApi.aktivierung.dialog.fehler'));
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="flex flex-col gap-6 p-8 sm:max-w-[444px]">
        <DialogTitle>{t('domain.e2nApi.aktivierung.dialog.title')}</DialogTitle>

        <div className="text-sm text-neutrals-900">
          {t('domain.e2nApi.aktivierung.dialog.description')}
        </div>

        <div className="flex items-center justify-end gap-4">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            {t('domain.e2nApi.aktivierung.dialog.abbrechen')}
          </Button>
          <Button onClick={handleConfirm} disabled={loading}>
            {t('domain.e2nApi.aktivierung.dialog.bestaetigen')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
